/**
 * @description table颗粒组件-联系用户erp
 * @param { userName: string | reactNode[姓名], userErp: string | reactNode[erp账号], showDoint:boolean[是否显示短线-] }
 * @returns 联系用户erp component or '-'
 */
import React from 'react';
import Dongdong from '@/components/dongdong';

export default function TableContactUser(props) {
  const { userName, userErp, showDoint = true } = props;

  return <>{userName || userErp ? <Dongdong name={userName} erp={userErp} /> : <>{showDoint ? '-' : ''}</>}</>;
}
